import { useState, useEffect } from 'react';
import { useOrganization } from '../../../contexts/OrganizationContext';
import { getOrganizationInvoices, getLatestPaidInvoice, Invoice } from '../../../services/modules/billing/invoices.service';

export const useInvoices = () => {
    const { currentOrganization } = useOrganization();
    const [invoices, setInvoices] = useState<Invoice[]>([]);
    const [latestInvoice, setLatestInvoice] = useState<Invoice | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!currentOrganization?.id) return;

        const fetchInvoices = async () => {
            setIsLoading(true);
            try {
                // Buscamos todas para histórico e a última para display rápido
                const [all, latest] = await Promise.all([
                    getOrganizationInvoices(currentOrganization.id),
                    getLatestPaidInvoice(currentOrganization.id)
                ]);
                setInvoices(all);
                setLatestInvoice(latest);
            } catch (error) {
                console.error('Failed to load invoices', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchInvoices();
    }, [currentOrganization?.id]);

    return {
        invoices,
        latestInvoice,
        isLoading
    };
};
